import { Coord, GridConfig } from "../../../../../../../../../src/types/Interface";
import { LineCoords } from "../types";


export default function getLineCoords(GridConfig: GridConfig, originPoint: Coord): LineCoords {
  const GF = GridConfig;

  return {
    originCoord: {
      x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
      y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize,
    },
    endCoords: [
      {
        x: GF.x - GF.width / 2,
        y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize,
      },
      {
        x: GF.x + GF.width / 2,
        y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize,
      },
      {
        x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
        y: GF.y + GF.height / 2,
      },
      {
        x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
        y: GF.y - GF.height / 2,
      }
    ]
  }
}